module.exports = __webpack_public_path__ + "img/Banner3_E.a03f484f.jpg";